var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import resolvePath from 'utils/resolvePath';
import getAuthToken from 'utils/getAuthToken';
import qs from 'qs';
import dateTime from 'utils/dateTime';
// Action
const GET_TENCENTSDKINFO_REQUEST = 'tencentSdkInfo/getTencentSdkInfoRequest';
const GET_TENCENTSDKINFO_SUCCESS = 'tencentSdkInfo/getTencentSdkInfoSuccess';
const GET_TENCENTSDKINFO_FAILURE = 'tencentSdkInfo/getTencentSdkInfoFailure';
// Action Creator
export const getTencentSdkInfoRequest = () => {
    return {
        type: GET_TENCENTSDKINFO_REQUEST,
    };
};
export const getTencentSdkInfoSuccess = (tencentSdkInfo) => {
    return {
        payload: {
            tencentSdkInfo,
        },
        type: GET_TENCENTSDKINFO_SUCCESS,
    };
};
export const getTencentSdkInfoFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TENCENTSDKINFO_FAILURE,
    };
};
export const getTencentSdkInfo = (recursive = false) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(getTencentSdkInfoRequest());
    const authToken = getAuthToken();
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const parameters = {
        timestamp: dateTime.now().toSeconds(),
        reset: recursive,
    };
    return axios
        .get(`${resolvePath.api('tencent_sdk_info')}?${qs.stringify(parameters)}`, config)
        .then((response) => dispatch(getTencentSdkInfoSuccess(response.data)))
        .catch((error) => {
        if (recursive === false) {
            return getTencentSdkInfo(true);
        }
        else {
            dispatch(getTencentSdkInfoFailure(error));
            throw error;
        }
    });
});
const initialState = {
    tencentSdkInfo: {
        tencent_sdk_app_id: '',
        user_sig: '',
    },
    error: null,
    isFetching: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_TENCENTSDKINFO_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_TENCENTSDKINFO_SUCCESS: {
            return Object.assign(Object.assign({}, state), { tencentSdkInfo: Object.assign({}, action.payload.tencentSdkInfo), isFetching: false });
        }
        case GET_TENCENTSDKINFO_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
